var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "big-slider" }, [
    _c("div", { ref: "bigSwiper", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "swiper-slide",
              class: { reverse: _vm.reverse, outline: _vm.hasoutline }
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-block",
                  attrs: { "data-aos": "fade-up", "data-aos-duration": "400" }
                },
                [
                  _c("responsive-image", {
                    staticClass: "image",
                    attrs: { src: item.image_data }
                  }),
                  _vm._v(" "),
                  _vm.stamp.stamp_show
                    ? _c("stamp", { attrs: { stamp: _vm.stamp } })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-block" }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("h2", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "section-description",
                    domProps: { innerHTML: _vm._s(item.text) }
                  }),
                  _vm._v(" "),
                  item.button_link
                    ? _c(
                        "a",
                        {
                          staticClass: "btn",
                          attrs: { href: item.button_link }
                        },
                        [_vm._v(_vm._s(item.button_label))]
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
    _vm._v(" "),
    _c("div", { ref: "next", staticClass: "swiper-button-next" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }